// extracted by mini-css-extract-plugin
module.exports = {"root":"BylinePhoto__root--szGxO"};